import JsonField from './JsonField.js'
import formats from '../../../api/formats'
import favorite from '../../favorite'
import dialogs from '../../common/dialogs.js'

export default
class CompanyBankField extends JsonField {
  getStrategy () {
    return favorite.createStrategy(this.cxt.context, this.type)
  }
  getDescription (model) {
    let obj = model[this.name] ? JSON.parse(model[this.name]) : null
    if (!obj) {
      return ''
    }
    return `${obj.name}`
  }
  open (model, onChange) {
    const key = this.getCode(model)
    const companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name)
    if (!this.checkCompanyRefCode(companyRefCode)) {
      return
    }
    favorite.getCompanyRef(companyRefCode).then((props) => {
      favorite.openCompanyBank(key, props.ref.ref, props.ref.caption, props.clientCompanyId).then((key) => {
        this.setCode(model, key, onChange)
      })
    })
  }
  select (model, onChange) {
    const getQuery = () => {
      return this.getCode(model) ? this.getCode(model) : ''
    }
    const companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name)
    if (!this.checkCompanyRefCode(companyRefCode)) {
      return
    }
    favorite.getCompanyRef(companyRefCode).then((props) => {
      return new Promise((resolve, reject) => {
        if (props && props.banks && props.banks.length > 0) {
          favorite.selectCompanyBankByInn(this.cxt.context, props.ref.ref, getQuery).then((data) => resolve(data))
        } else {
          favorite.openCompanyBank(null, props.ref.ref, props.ref.caption, props.clientCompanyId).then((data) => {
            resolve([data])
          })
        }
      })
    })
    .then((values) => {
      if (Array.isArray(values) && values.length > 0) {
        this.setCode(model, values[0], onChange)
      }
    })
  }
  checkCompanyRefCode (refCode) {
    if (formats.isRefCode(refCode)) {
      return true
    }
    dialogs.message(this, 'Совет', 'Сначала выберите компанию')
    return false
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/CompanyBankField.js